import { createAction, props } from '@ngrx/store';

export const changePasswordSave = createAction(
    '[changePassword] Change Password',
    props<{ currentPassword: string, newPassword: string, confirmPassword: string}>()
);

export const changePasswordReset = createAction(
    '[changePassword] Change Password Reset'
);

export const changePasswordSuccess = createAction(
    '[changePassword] Change Password Success'
);
